<template>
    <VButton class="table-name-label secondary outlined" v-if="allocation.allocation != null">
        {{ tableLabel }}
    </VButton>
</template>

<script setup lang="ts">
    import { useBillStore } from "@/data/stores/bill";
    import { useTableAllocationStore } from "@/data/stores/tableAllocation";
    import { computed } from "vue";

    import VButton from "@/components/elements/VButton.vue";

    const allocation = useTableAllocationStore();
    const bill = useBillStore();

    const tableLabel = computed(() => {
        if (bill.currentBill == null || bill.currentBill.customName == null) {
            return allocation.allocation?.tableName;
        } else {
            return allocation.allocation?.tableName + " / " + bill.currentBill.customName;
        }
    });
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .table-name-label {
        font-size: 14px;
        padding: 0 calc(1em - 2px);
    }
</style>
